export default function formatName(name) {
  return name.replace(/\s|-/g, '_')
}



// WEBPACK FOOTER //
// ../src/components/Input/utils/formatFieldName.js